__turbopack_context__.v({
  "form": "register-module__qzo3ya__form",
  "heading": "register-module__qzo3ya__heading",
  "loginLink": "register-module__qzo3ya__loginLink",
  "main": "register-module__qzo3ya__main",
  "message": "register-module__qzo3ya__message",
  "page": "register-module__qzo3ya__page",
  "panel": "register-module__qzo3ya__panel",
  "passwords": "register-module__qzo3ya__passwords",
  "terms": "register-module__qzo3ya__terms",
});
